import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
  forwardRef,
} from "@angular/core";
import { ToolBarToolComponent } from "@progress/kendo-angular-toolbar";
import {
  KENDO_DROPDOWNLIST,
  DropDownListComponent,
} from "@progress/kendo-angular-dropdowns";
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { KENDO_DIALOG } from "@progress/kendo-angular-dialog";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { SVGIcon, heartIcon } from "@progress/kendo-svg-icons";

@Component({
  standalone: true,
  providers: [
    {
      provide: ToolBarToolComponent,
      useExisting: forwardRef(() => CustomToolComponent),
    },
  ],
  selector: "app-custom-tool",
  imports: [KENDO_BUTTONS, KENDO_DIALOG, KENDO_DROPDOWNLIST, KENDO_LABEL],
  template: `
    <ng-template #toolbarTemplate>
      <span #toolbarElement>
        <kendo-label [text]="text">
          <!--
          <kendo-dropdownlist
            #dropdownlist
            defaultItem="Select sport..."
            [style.marginLeft.px]="5"
            [tabindex]="tabindex"
            [data]="items"
            [itemDisabled]="itemDisabled"
            [(value)]="value"
          >
          </kendo-dropdownlist>
          -->
        </kendo-label>
      </span>
    </ng-template>
    <ng-template #popupTemplate>
      <span #popupElement>
        <button
          #button
          kendoButton
          style="width: 100%"
          [tabindex]="tabindex"
          [svgIcon]="heartIcon"
          (click)="opened = true"
        >
          Fav Sport
        </button>
      </span>

      @if (opened) {
        <kendo-dialog title="Select a favourite sport" (close)="opened = false">
          <kendo-dropdownlist
            defaultItem="Select sport..."
            [data]="items"
            [(value)]="value"
          >
          </kendo-dropdownlist>
          <kendo-dialog-actions>
            <button kendoButton (click)="opened = false">Ok</button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    </ng-template>
  `,
})
export class CustomToolComponent
  extends ToolBarToolComponent
  implements OnInit
{
  @Input() public text!: string;

  @ViewChild("toolbarTemplate", { static: true })
  declare public toolbarTemplate: TemplateRef<unknown>;
  @ViewChild("toolbarElement", { static: false })
  public toolbarElement!: ElementRef;

  @ViewChild("popupTemplate", { static: true })
  declare public popupTemplate: TemplateRef<unknown>;
  @ViewChild("popupElement", { static: false })
  public popupElement!: ElementRef;

  @ViewChild("dropdownlist", { read: DropDownListComponent, static: false })
  public dropdownlist!: DropDownListComponent;
  @ViewChild("button", { static: false }) public button!: ElementRef;

  public heartIcon: SVGIcon = heartIcon;
  public value!: string;
  public items: string[] = ["Badminton", "Tennis", "Squash"];
  public opened = false;
  public tabindex = -1;
  public itemDisabled!: (itemArgs: {
    dataItem: string;
    index: number;
  }) => boolean;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.itemDisabled = () =>
      !this.overflows && this.dropdownlist && !this.dropdownlist.isOpen;
  }

  public override canFocus(): boolean {
    return true;
  }

  public override focus(): void {
    this.tabindex = 0;
    if (this.overflows) {
      this.button.nativeElement.focus();
    } else {
      this.dropdownlist.focus();
    }
  }

  public override handleKey(): boolean {
    this.tabindex = -1;
    return false;
  }
}
